/** Proof of Identity */
export const CORPORATE_PROOF_OF_IDENTITY_TYPE = 1;

/** Proof of Residence */
export const CORPORATE_PROOF_OF_RESIDENCE_TYPE = 2;

export const hasCorporateProofOfIdentityDocument = (documents = []) =>
  documents.some(
    (doc) => Number(doc.proofType) === CORPORATE_PROOF_OF_IDENTITY_TYPE
  );

export const hasCorporateProofOfResidenceDocument = (documents = []) =>
  documents.some(
    (doc) => Number(doc.proofType) === CORPORATE_PROOF_OF_RESIDENCE_TYPE
  );

export const hasRequiredCorporateProofDocuments = (documents = []) =>
  hasCorporateProofOfIdentityDocument(documents) &&
  hasCorporateProofOfResidenceDocument(documents);

export const isCorporateProofRequirementSatisfied = (
  uploadedDocuments = [],
  pendingProofType = null
) => {
  if (hasRequiredCorporateProofDocuments(uploadedDocuments)) return true;

  if (pendingProofType == null) return false;

  const pending = Number(pendingProofType);
  const hasPoi = hasCorporateProofOfIdentityDocument(uploadedDocuments);
  const hasPor = hasCorporateProofOfResidenceDocument(uploadedDocuments);

  if (!hasPoi && pending === CORPORATE_PROOF_OF_IDENTITY_TYPE) return true;
  if (!hasPor && pending === CORPORATE_PROOF_OF_RESIDENCE_TYPE) return true;

  return false;
};

export const getCorporateRequiredProofValidationMessage = (t, documents = []) => {
  const hasPoi = hasCorporateProofOfIdentityDocument(documents);
  const hasPor = hasCorporateProofOfResidenceDocument(documents);

  if (hasPoi && !hasPor) {
    return t(
      "Proof of Residence is still required. Please upload your residence document."
    );
  }

  if (!hasPoi && hasPor) {
    return t(
      "Proof of Identity is still required. Please upload your identity document."
    );
  }

  return t(
    "Please upload both a Proof of Identity and a Proof of Residence document."
  );
};

export const getCorporateRequiredProofStatusMessage = (t, documents = []) => {
  const hasPoi = hasCorporateProofOfIdentityDocument(documents);
  const hasPor = hasCorporateProofOfResidenceDocument(documents);

  if (hasPoi && hasPor) {
    return t(
      "Proof of Identity and Proof of Residence documents are uploaded."
    );
  }

  if (hasPoi && !hasPor) {
    return t(
      "Proof of Identity uploaded. Please upload your Proof of Residence document to continue."
    );
  }

  if (!hasPoi && hasPor) {
    return t(
      "Proof of Residence uploaded. Please upload your Proof of Identity document to continue."
    );
  }

  return t(
    "Please upload both a Proof of Identity and a Proof of Residence document."
  );
};

export const clearCorporateProofDocumentFieldError = (form) => {
  form?.setFields([{ name: "document", errors: [] }]);
};

export const corporateRequiredProofDocumentRules = (
  uploadedDocuments,
  t,
  pendingProofType = null
) => [
  {
    validator: () =>
      isCorporateProofRequirementSatisfied(uploadedDocuments, pendingProofType)
        ? Promise.resolve()
        : Promise.reject(
            new Error(
              getCorporateRequiredProofValidationMessage(t, uploadedDocuments)
            )
          ),
  },
];

export const selectFilterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase().trim());

export const searchableSelectProps = {
  showSearch: true,
  filterOption: selectFilterOption,
  optionFilterProp: "label",
};
